import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';

export type DecisaoEdicaoItemPadrao =
  | { acao: 'redirecionar'; para: string }
  | { acao: 'aguardar' }
  | { acao: 'editar' };

/**
 * Numa pasta com item padrão, o "Editar" leva ao formulário do item padrão
 * (ver `Edit.jsx`). `?pasta=1` edita a própria pasta.
 *
 * O destino sai do `@id` do conteúdo carregado, nunca da URL: logo depois do
 * redirect a URL já é a do item, mas o store ainda guarda a pasta. Somar o
 * item padrão à URL de novo gerava `.../mpf/mpf/mpf/edit` sem fim (o Plone
 * resolve `mpf/mpf` para o mesmo objeto por aquisição). Nesse intervalo a
 * decisão é aguardar o item carregar.
 */
export const decidirEdicaoItemPadrao = (
  content:
    | { '@id'?: string; is_folderish?: boolean; default_page?: string }
    | null
    | undefined,
  pathname: string,
  pasta: string | null | undefined,
): DecisaoEdicaoItemPadrao => {
  if (!content?.is_folderish || !content.default_page || pasta === '1') {
    return { acao: 'editar' };
  }
  const destino = `${flattenToAppURL(content['@id'] ?? '')}/${content.default_page}`;
  if (getBaseUrl(pathname) === destino) {
    return { acao: 'aguardar' };
  }
  return { acao: 'redirecionar', para: `${destino}/edit` };
};

export default decidirEdicaoItemPadrao;
